import {
  authReq
} from '@/utils/http'

const getWechatAccountByUserId = (userId) => {
  return authReq.get('/api/v1/wechat_account', {
    'user_id': userId
  })
}

const addWechatAccount = (data) => {
  return authReq.post('/api/v1/wechat_account', {
    'user_id': data.userId,
    'account_name': data.accountName,
    'original_id': data.originalId,
    'app_id': data.appId,
    'app_secret': data.appSecret,
    'token': data.token,
    'encoding_aes_key': data.encodingAesKey,
    'domain': data.domain,
    'offline_tpl': data.offlineTpl,
    'refund_tpl': data.refundTpl,
    'abnormal_tpl': data.abnormalTpl,
    'stock_tpl': data.stockTpl,
    'remarks': data.remarks
  })
}

const updateWechatAccount = (data) => {
  return authReq.put('/api/v1/wechat_account', {
    'user_id': data.userId,
    'account_name': data.accountName,
    'original_id': data.originalId,
    'app_id': data.appId,
    'app_secret': data.appSecret,
    'token': data.token,
    'encoding_aes_key': data.encodingAesKey,
    'domain': data.domain,
    'offline_tpl': data.offlineTpl,
    'refund_tpl': data.refundTpl,
    'abnormal_tpl': data.abnormalTpl,
    'stock_tpl': data.stockTpl,
    'remarks': data.remarks
  })
}

const deleteWechatAccount = (data) => {
  return authReq.delete('/api/v1/wechat_account', {
    'user_id': data.userId,
    'app_id': data.appId
  })
}

const listWechatQrcode = (data) => {
  return authReq.get('/api/v1/wechat_account/qrcode', {
    page: data.page,
    'page_size': data.pageSize,
    sort: data.sort,
    ...data.filters
  })
}

const addWechatQrcode = (data) => {
  return authReq.post('/proxy/p/api/v1/p/createSubQrcodeForOper', {
    'app_id': data.appId,
    'sn': data.sn,
    'qrcode': [
      {
        'channel_road': data.qrcode.channelRoad,
        'dev_type': data.qrcode.devType,
        'buy_mode': data.qrcode.buyMode,
        'sub_action': data.qrcode.subAction,
        'sub_extend': data.qrcode.subExtend,
        'action_name': data.qrcode.actionName,
        'expire_seconds': data.qrcode.expireSeconds,
        'exchange_limit': data.qrcode.exchangeLimit
      }
    ]
  })
}

const getWechatAccountMenu = (userId) => {
  return authReq.get('/api/v1/wechat_account/menu', {
    'user_id': userId
  })
}

const addWechatAccountMenu = (data) => {
  return authReq.post(`/api/v1/wechat_account/menu?user_id=${data.userId}`, data.menu)
}

export default {
  getWechatAccountByUserId,
  addWechatAccount,
  updateWechatAccount,
  deleteWechatAccount,
  listWechatQrcode,
  addWechatQrcode,
  getWechatAccountMenu,
  addWechatAccountMenu
}



// WEBPACK FOOTER //
// ./src/api/wechatAccountApi.js